import React, { FC, ReactNode } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";

import TrendIndicator, { TrendDirection } from "../TrendIndicator";

type KPICardProps = {
  label: string;
  value: string | number;
  change?: string;
  trend?: TrendDirection;
  icon?: ReactNode;
};

const Card = styled("div")(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.white,
  borderRadius: 10,
  padding: "20px 24px",
  border: `1px solid ${theme.palette.brand.gray200}`,
  flex: 1,
  minWidth: 190,
  transition: "border-color 0.15s",
  "&:hover": {
    borderColor: theme.palette.brand.gray300,
  },
}));

const TopRow = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: 12,
});

const Label = styled("span")(({ theme }: { theme: Theme }) => ({
  fontSize: 13,
  color: theme.palette.brand.gray500,
  fontWeight: 500,
}));

const IconWrap = styled("div")(({ theme }: { theme: Theme }) => ({
  width: 36,
  height: 36,
  borderRadius: 8,
  background: theme.palette.brand.gray50,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
}));

const Value = styled("div")(({ theme }: { theme: Theme }) => ({
  fontSize: 28,
  fontWeight: 700,
  color: theme.palette.brand.gray900,
  letterSpacing: "-0.02em",
}));

const ChangeRow = styled("div")({
  marginTop: 8,
});

const DefaultIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="1.8">
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </svg>
);

const KPICard: FC<KPICardProps> = ({ label, value, change, trend, icon }) => (
  <Card>
    <TopRow>
      <Label>{label}</Label>
      <IconWrap>{icon ?? <DefaultIcon />}</IconWrap>
    </TopRow>
    <Value>{value}</Value>
    {change && trend && (
      <ChangeRow>
        <TrendIndicator direction={trend} label={`${change} vs last month`} />
      </ChangeRow>
    )}
  </Card>
);

export default KPICard;
